<template>
  <div class='item-slider'>
    <div class='content'>
      <div class='img-box'>
        <img :src='getImagePath' class='item-slider__img' :class='{"mini": imgMini}' alt='slider' />
      </div>
      <div class='text-box'>
        <h4 class='title'>{{ title }}</h4>
        <span>
          <slot name="description"></slot>
        </span>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'SliderItemLogin',
  props: {
    imgName: {
      type: String,
      default: ''
    },
    title: {
      type: String,
      default: ''
    },
    text: {
      type: String,
      default: ''
    },
    link: {
      type: String,
      default: ''
    },
    linkText: {
      type: String,
      default: ''
    },
    imgMini: {
      type: Boolean,
      default: false
    }
  },
  computed: {
    getImagePath() {
      if (this.imgName) {
        return require(`@/assets/img/sliders/${this.imgName}`);
      } else return '';
    }
  }
};
</script>

<style scoped lang='scss'>
.item-slider {
  width: 100%;
  background: $color-base;
  height: 100%;
  overflow: hidden !important;

  & .content {
    display: flex;
    flex-direction: row;
    align-items: center;
    justify-content: center;
    padding: 20px 20px 50px;
    height: 100%;
    box-sizing: border-box;

    @media screen and (max-width: $gr-sm) {
      padding-top: 20px;
      padding-bottom: 50px;
    }
    @media screen and (max-width: $gr-md) {
      padding-top: 20px;
      padding-bottom: 50px;
    }
  }

  & .img-box {
    margin-right: 40px;

    img {
      height: 100px;
      width: 100px;
    }

    img.mini {
      height: 70px;
      width: 70px;
    }
  }

  & .text-box {

    & .title {
      font-size: $font-size-middle-level-1 !important;
      color: white;
      width: 100%;
      line-height: 20px;
      margin-bottom: 20px;

      @media screen and (max-width: $gr-sm) {
        font-size: $font-size-middle-level-2 !important;
      }
    }

    & .description {
      font-size: $font-size-small !important;
      color: white;
      margin-top: 10px;
      width: 230px;
      line-height: 13px;
    }

    & .link {
      font-size: $font-size-small !important;
      line-height: 13px;
      color: white;
      margin-top: 10px;
      width: 230px;
      text-decoration: underline;
    }
  }

  &.full {
    .content {
      justify-content: unset;
      padding: 30px 10% 80px;

      @media screen and (max-width: $gr-md) {
        padding: 20px 5% 50px;
      }
    }
  }
}

</style>
